export const standardDateFormat = 'YYYY-MM-DD';
export const excelDateFormat = 'DD/MM/YYYY';
export const comboBoxWidth = 310;
export const comboBoxHeight = 320;
export const izireportVersion = "3.1"; // don't forget to change the version in manifest.template.ejs
export const izireportAppName = "PMIziReportOnline";
export const izireportIdentifier = `${Office.context.diagnostics.host.toString()}-${Office.context.diagnostics.platform.toString()}-${Office.context.diagnostics.version.toString()}`;
export const COMPUTATION_MAX_CONCURRENT = "100";